import type { Property } from '~/api/gen'
import { propertyTransactionTypeEnum, statePropertyEnum } from '~/api/gen'
import { trackingFinalisation } from '../lifecycle'

const id = '3'
const reference = 'REF-AGRI-001'

export const venteBienAgricoleDetail: Property = {
  id,
  reference,
  transactionType: propertyTransactionTypeEnum.SALE,
  propertyType: 'PAGV',
  propertySubType: 'BATIMENT_AGRICOLE',
  status: statePropertyEnum.ACTIVE,
  trackingStatus: trackingFinalisation,
}
